module.exports = require("d3-shape");


/*****************
 ** WEBPACK FOOTER
 ** external "d3-shape"
 ** module id = 141
 ** module chunks = 0
 **/